module.exports = __webpack_public_path__ + "img/pattern-oval.aa57dc6b.svg";